import { render } from "./CardsTablePanel.vue?vue&type=template&id=40569a5d&scoped=true&ts=true&lang=pug"
import script from "./CardsTablePanel.vue?vue&type=script&lang=ts"
export * from "./CardsTablePanel.vue?vue&type=script&lang=ts"

import "./CardsTablePanel.vue?vue&type=style&index=0&id=40569a5d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40569a5d"]])

export default __exports__